import React from 'react';
import {
  Container,
  Typography,
  Box,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import { MembershipForm } from '../../features/membership-form.tsx/membership-form';
import { MembershipTrainerData } from '.';

const usetyles = makeStyles(() =>
  createStyles({
    root: {
      // minHeight: '100vh',
    },
  })
);

interface Props {
  trainerData: MembershipTrainerData;
}

export const TrainerMembershipMobile: React.FC<Props> = ({ trainerData }) => {
  const classes = usetyles();
  return (
    <Container className={classes.root}>
      <Box mt={3} />
      <Typography variant="h5">Start for Free</Typography>
      <Box mt={3} />
      <MembershipForm trainerData={trainerData} />
    </Container>
  );
};
